<template>
<!--  <div>-->
<!--    <el-row :gutter="10">-->
<!--        <el-col :span="4" >-->
<!--          <div style="background-color: #2c77ec;">12312312</div>-->
<!--        </el-col>-->
<!--      <el-col :span="0.1">-->
<!--        <div style="background-color: #eff0f5;"></div>-->
<!--      </el-col>-->
<!--      <el-col :span="18">-->
        <div>
          <el-main>
            <el-dialog title="新增" :visible.sync="dialogFormVisible">
              <el-form :model="dialogform">
                <el-form-item label="问题" :label-width="formLabelWidth">
                  <el-input v-model="question" autocomplete="off" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="答案" :label-width="formLabelWidth">
                  <el-input
                    type="textarea"
                    :rows="5"
                    placeholder="请输入内容"
                    v-model="textarea">
                  </el-input>
                </el-form-item>
                <!--        <el-form-item label="分类" :label-width="formLabelWidth" style="text-align: left;">-->
                <!--          <el-select placeholder="分类" v-model="value" @change="innertypechange">-->
                <!--            <el-option v-for="(item,index) in qstypes" v-if="item.labelName!= ''" :key="index" :label="item.labelName" :value="item.labelName"></el-option>-->
                <!--          </el-select>-->
                <!--        </el-form-item>-->
                <el-form-item label="热点问题" :label-width="formLabelWidth" style="text-align: left;">
                  <el-radio v-model="ishot" label="false">否</el-radio>
                  <el-radio v-model="ishot" label="true">是</el-radio>
                </el-form-item>
              </el-form>
              <el-dialog
                width="30%"
                title="新增分类"
                :visible.sync="innerVisible"
                append-to-body>
                <el-form :model="form">
                  <el-form-item label="类型名称" :label-width="formLabelWidth">
                    <el-input v-model="innertypename" autocomplete="off"></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="innerVisible = false">取 消</el-button>
                  <el-button type="primary" @click="addLabel">确 定</el-button>
                </div>
              </el-dialog>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addQuestionDialog" :loading="isLoading">确 定</el-button>
              </div>
            </el-dialog>
            <div>
              <el-form ref="formInline" :inline="true" :model="formInline" class="demo-form-inline"  style="float: left;text-align: left;padding-top:10px ;">
                <el-form-item label="问题筛选" prop="type">
                  <el-input  v-model="qaSelect" placeholder="请输入问题关键字" maxlength="50" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button  type="primary" icon="el-icon-search" @click="typechange"></el-button>
                </el-form-item>
              </el-form>
              <div style="padding: 10px 0px;text-align: left;float: right">
                <el-button type="primary" @click="addQuestion">新增</el-button>
                <el-button type="primary" @click="openAdd()">导入</el-button>
              </div>
            </div>
            <el-table id="dataTable" :data="dataList" :border="border" :height="tableHeight"
                      style="height:auto;" :header-cell-style="tableHeaderColor">
              <el-table-column header-align="center" label="问题" width="550" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-html="scope.row.question "></div>
                </template>
              </el-table-column>
              <el-table-column header-align="center" label="问题咨询次数" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: center" v-html="scope.row.total "></div>
                </template>
              </el-table-column>
              <!--      <el-table-column header-align="center" label="答案" width="800" show-overflow-tooltip>-->
              <!--        <template slot-scope="scope">-->
              <!--            <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-html="scope.row.answer "></div>-->
              <!--        </template>-->
              <!--      </el-table-column>-->
              <el-table-column header-align="center" label="满意" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: center" v-html="scope.row.praiseNum "></div>
                </template>
              </el-table-column>
              <el-table-column header-align="center" label="不满意" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: center" v-html="scope.row.slanderNum "></div>
                </template>
              </el-table-column>

              <el-table-column header-align="center" prop="createTime" label="创建时间" width="180" ></el-table-column>
              <el-table-column header-align="center" align="center" label="操作" width="200" >
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" style="color: #FFFFFF"  @click="changeQaInfo(scope.row)">修改</el-button>
                  <el-button size="mini" class="grey"  @click="open(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top:40px;right:10px; width:100%; text-align:right;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalPageNum">
              </el-pagination>
            </div>
            <!-- 修改信息弹窗-->
            <el-dialog title="问答修改" :visible.sync="changedialogFormVisible">
              <el-form :model="changeinfoform">
                <el-form-item label="问题" :label-width="formLabelWidth">
                  <el-input   v-model="changeinfoform.c_question"  autocomplete="off" maxlength="100"></el-input>
                </el-form-item>
                <!--         <el-form-item label="类型" :label-width="formLabelWidth" style="text-align: left;">-->
                <!--           <el-select placeholder="类型" v-model="changevalue" @change="innertypechange">-->
                <!--             <el-option v-for="(item,index) in qstypes" v-if="item.labelName!= ''" :key="index" :label="item.labelName" :value="item.labelName"></el-option>-->
                <!--           </el-select>-->
                <!--        </el-form-item>-->

                <el-form-item label="问题咨询次数" :label-width="formLabelWidth"   style="text-align: left;">
                  <el-input   v-model="changeinfoform.total" readonly autocomplete="off" ></el-input>
                </el-form-item>
                <el-form-item label="满意" :label-width="formLabelWidth" disabled="true" style="text-align: left;">
                  <el-input   v-model="changeinfoform.praiseNum" readonly autocomplete="off" ></el-input>
                </el-form-item>
                <el-form-item label="不满意" :label-width="formLabelWidth"  disabled="true" style="text-align: left;">
                  <el-input   v-model="changeinfoform.slanderNum" readonly autocomplete="off" ></el-input>
                </el-form-item>
                <el-form-item label="答案" :label-width="formLabelWidth">
                  <el-input
                    type="textarea"
                    :rows="5"
                    placeholder="请输入内容"
                    v-model="changeinfoform.c_answer">
                  </el-input>
                </el-form-item>
                <el-form-item label="热点问题" :label-width="formLabelWidth" style="text-align: left;">
                  <el-radio v-model="changeinfoform.c_ishot" label="false">否</el-radio>
                  <el-radio v-model="changeinfoform.c_ishot" label="true">是</el-radio>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="changedialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="changeDialog()" :loading="isLoading">确 定</el-button>
              </div>
            </el-dialog>
          </el-main>
          <el-dialog
            title="导入"
            :visible.sync="dialogVisible"
            width="30%"
          >
            <el-upload
              class="upload-demo"
              ref="upload"
              :action="$CFG.fileUploadUrl"
              :on-preview="handlePreview"
              :on-success="success"
              :on-error="uploadFileError"
              :on-remove="handleRemove"
              :headers="{token}"
              accept=".xls,.xlsx"
              :data="{siteId:siteId}"
              :file-list="fileList">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <a :href="`${$CFG.fileDownload}`" target="_blank" class="el-button el-button--success el-button--small">下载模板</a>
              <div slot="tip" class="el-upload__tip">只能上传Excel文件</div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
  </span>
          </el-dialog>
        </div>
<!--      </el-col>-->
<!--    </el-row>-->
<!--  </div>-->

</template>

<script>
// import $ from 'jquery'
import { getQAList, getQALType, addLabel, addQA, delQA, updateQA} from '@/api/common'
export default {
  name: 'personsend',
  data () {
    return {
      siteId: '',
      token: sessionStorage.getItem('token'),
      fileList: [],
      currentPage: 1,
      totalPageNum: 0,
      choiceformList: [],
      nameList: [],
      dataList: [],
      qaSelect: '',
      tableHeight: '200px',
      border: false,
      selectedRowId: '',
      ishot: 'false',
      colShow: false,
      total: 0,
      dialogFormVisible: false,
      changedialogFormVisible: false,
      closeOnClick: false,
      showClose: false,
      pageSize: 10,
      pageNow: 0,
      sQuestion: '',
      dialogVisible: false,
      formInline: {
        user: '',
        type: '',
        date: ''
      },
      form: {},
      changeinfoform: {
        c_question: '',
        c_answer: '',
        c_type: '',
        c_ishot: '',
        praiseNum: '',
        total: '',
        slanderNum: ''
      },
      dialogform: {
        region: ''
      },
      question: '',
      qstypes: [{
        labelId: '',
        labelName: '全部'
      }],
      formLabelWidth: '120px',
      innerVisible: false,
      childtype1: '',
      childtype2: '',
      innertypename: '',
      value: '',
      textarea: '',
      id: '',
      qaType: '',
      userId: '15678902834',
      selectrow: '',
      innerTypeSelect: '',
      changevalue: '',
      msg: '',
      isLoading: false
    }
  },
  created () {
    this.userId = localStorage.getItem('userId')
    this.tableHeight = window.innerHeight - 330 + 'px'
    window.onresize = () => {
      return (() => {
        this.tableHeight = window.innerHeight - 330 + 'px'
      })()
    }
  },
  mounted: function () {
    this.siteId = ''
    this.msg = this.$route.query.id
    this.siteId = this.$route.query.siteId
    let params = {
      pageSize: this.pageSize,
      pageNow: this.pageNow,
      siteId: this.siteId
    }
    this.getQALType()
    this.getQAList(params)
    this.dialogVisible = false

    // alert(this.$route.query.stationId)
    console.info(this.msg)
    if (this.msg === '2') {
      this.$notify({
        title: '提示',
        message: '您可以在添加或者修改问题时，设置热点问题。',
        type: 'success',
        duration: 6000
      })
    }
  },
  // watch: {
  //   node: function (value) {
  //     console.info(value)
  //   }
  // },
  methods: {
    openAdd () {
      if (this.siteId === undefined || this.siteId === '') {
        this.$notify({
          title: '提示',
          message: '请先选择站点',
          type: 'warning'
        })
        return
      }
      this.fileList = []
      this.dialogVisible = true
    },
    success (response) {
      // console.info('reponse: ', response)
      if (response.ret === 1) {
        let count = response.content.importCount
        let failCount = response.content.failCount
        if (count <= 0) {
          this.$notify({
            title: '提示',
            message: '导入完成，但没有导入任何记录。',
            type: 'success'
          })
        } else {
          this.$notify({
            title: '提示',
            message: '导入成功' + count + '条,失败' + failCount + '条',
            type: 'success'
          })
        }
      } else {
        this.isLoading = false
        this.$notify({
          title: '提示',
          message: '导入失败，请重试。',
          type: 'warning'
        })
      }
      this.pageNow = 0
      let params = {
        pageSize: this.pageSize,
        pageNow: this.pageNow,
        qaSelect: this.qaSelect,
        siteId: this.siteId
      }
      this.currentPage = 1
      this.value = ''
      this.getQAList(params)
      this.dialogVisible = false
    },
    uploadFileError (err, file, fileList) {
      this.$notify({
        title: '提示',
        message: '导入失败，请重试。',
        type: 'warning'
      })
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    changeQaInfo (row) {
      if (this.siteId === undefined || this.siteId === '') {
        this.$notify({
          title: '提示',
          message: '请先选择站点',
          type: 'warning'
        })
        return
      }
      this.isLoading = false
      this.changedialogFormVisible = true
      this.selectrow = row
      let updateqa = row.question.replace(/<font color='red'>/g, '')
      updateqa = updateqa.replace(/<\/font>/g, '')
      this.changeinfoform.c_question = updateqa
      this.changeinfoform.c_answer = row.answer
      this.changeinfoform.c_ishot = row.isHotQuestion

      this.changeinfoform.total = row.total
      this.changeinfoform.praiseNum = row.praiseNum
      this.changeinfoform.slanderNum = row.slanderNum

      this.changevalue = row.typeFirst
      this.innerTypeSelect = row.typeFirst
    },
    changeDialog () {
      this.isLoading = true
      this.updateQA()
    },
    addQuestionDialog () {
      if (this.question === '') {
        this.$notify({
          title: '提示',
          message: '问题不能为空',
          type: 'warning'
        })
        return
      }
      if (this.textarea === '') {
        this.$notify({
          title: '提示',
          message: '答案不能为空',
          type: 'warning'
        })
        return
      }
      // if (this.innerTypeSelect === '') {
      //   this.$notify({
      //     title: '提示',
      //     message: '分类不能为空',
      //     type: 'warning'
      //   })
      //   return
      // }
      this.isLoading = true
      let params = {
        id: this.uuid(),
        question: this.question,
        answer: this.textarea,
        typeFirst: this.innerTypeSelect,
        typeSecond: this.childtype1,
        typeThird: this.childtype2,
        quesFrom: this.userId,
        quesType: this.userId,
        isHotQuestion: this.ishot,
        siteId: this.siteId
      }
      this.addQA(params)
    },
    typechange (evt) {
      let target = evt.target
      // 根据button组件内容 里面包括一个span标签，如果设置icon，则还包括一个i标签，其他情况请自行观察。
      // 所以，在我们点击到button组件上的文字也就是span标签上时，直接执行e.target.blur()不会生效，所以要加一层判断。
      if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
        target = evt.target.parentNode
      }
      target.blur()

      let e = this.qaSelect
      this.pageNow = 0
      this.currentPage = 1
      let params = ''
      if (e === '') {
        params = {
          pageSize: this.pageSize,
          pageNow: this.pageNow,
          siteId: this.siteId
          // userId: this.userId
        }
      } else {
        params = {
          pageSize: this.pageSize,
          pageNow: this.pageNow,
          qaSelect: e,
          siteId: this.siteId
          // userId: this.userId
        }
      }
      this.getQAList(params)
    },
    innertypechange (e) {
      console.log('选中的值' + e)
      this.innerTypeSelect = e
    },
    addQuestion () {
      if (this.siteId === undefined || this.siteId === '') {
        this.$notify({
          title: '提示',
          message: '请先选择站点',
          type: 'warning'
        })
        return
      }
      this.isLoading = false
      this.question = ''
      this.textarea = ''
      this.innerTypeSelect = ''
      this.value = ''
      this.childtype1 = ''
      this.childtype2 = ''
      this.ishot = 'false'
      this.dialogFormVisible = true
    },
    /* 点击切换先去修改分配状态
    * status 1 是自动分配
    * status 0是全员分配 */
    tableHeaderColor ({ row, column, rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #f0f0f0;'
      }
    },
    selectTrigger (val) {
    },
    uuid () { // 生成uid
      let s = []
    	let hexDigits = '0123456789abcdef'
    	for (let i = 0; i < 36; i++) {
    		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    	}
    	s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
    	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
    	s[8] = s[13] = s[18] = s[23] = '-'

    	let uuid = s.join('')
    	return uuid
    },
    // 修改问答
    updateQA () {
      let url = '/updateQA'
      let params = {
        id: this.selectrow.id,
        questionId: this.selectrow.questionId,
        createTime: this.selectrow.createTime,
        question: this.changeinfoform.c_question,
        answer: this.changeinfoform.c_answer,
        isHotQuestion: this.changeinfoform.c_ishot,
        typeFirst: this.innerTypeSelect,
        quesFrom: this.userId,
        quesType: this.userId,
        siteId: this.siteId
      }
      updateQA(url, params).then(response => {
        if (response.data.ret === 1) {
          this.changedialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success'
          })
          this.value = ''
          let params = {
            pageSize: this.pageSize,
            pageNow: this.pageNow,
            qaSelect: this.qaSelect,
            siteId: this.siteId
          }
          this.getQAList(params)
        } else {
          this.isLoading = false
          this.$notify({
            title: '提示',
            message: response.data.message,
            type: 'warning'
          })
        }
      }).catch(response => {
        this.isLoading = false
        this.$notify({
          title: '提示',
          message: '修改失败，请重试',
          type: 'warning'
        })
      })
    },
    open (row) {
      this.$confirm('此操作将删除该问答, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delQA(row)
      }).catch(() => {
        this.$notify({
          title: '提示',
          message: '已取消删除',
          type: 'warning'
        })
      })
    },
    // 删除问答
    delQA (row) {
      // console.log('删除啊：' + row.id)
      let url = '/delQA'
      let params = {
        qaId: row.id
      }
      delQA(url, params).then(response => {
        // console.log('删除几口' + JSON.stringify(response))
        if (response.data.ret === 1) {
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success'
          })
          this.value = ''
          let params = {
            pageSize: this.pageSize,
            pageNow: this.pageNow,
            qaSelect: this.qaSelect,
            siteId: this.siteId
          }
          this.getQAList(params)
        }
      }).catch(response => {
        this.$notify({
          title: '提示',
          message: '删除失败，请重试',
          type: 'warning'
        })
      })
    },
    // 添加问答
    addQA (params) {
      let url = '/addQA'
      addQA(url, params).then(response => {
        // console.log('获取人员列表'+JSON.stringify(response))
        if (response.data.ret === 1) {
          this.$notify({
            title: '成功',
            message: '添加成功',
            type: 'success'
          })
          this.dialogFormVisible = false
          this.currentPage = 1
          this.pageNow = 0
          this.value = ''
          let params = {
            pageSize: this.pageSize,
            pageNow: this.pageNow,
            qaSelect: this.qaSelect,
            siteId: this.siteId
          }
          this.getQAList(params)
        } else {
          this.isLoading = false
          this.$notify({
            title: '提示',
            message: response.data.message,
            type: 'warning'
          })
        }
      }).catch(response => {
        this.isLoading = false
        this.$notify({
          title: '提示',
          message: '添加失败，请重试',
          type: 'warning'
        })
      })
    },
    // 新增问答
    addLabel () {
      let url = '/addLabel'
      let params = {
        userId: this.userId,
        label: this.innertypename
      }
      addLabel(url, params).then(response => {
        console.log('类型添加成功：' + JSON.stringify(response))
        if (response.data.ret === 1) {
          this.innerVisible = false
          this.$notify({
            title: '成功',
            message: '类型添加成功',
            type: 'success'
          })
          this.qstypes.push({
            labelId: '',
            labelName: this.innertypename
          })
        }
      }).catch(response => {
        this.$notify({
          title: '提示',
          message: '添加问答分类失败，请重试',
          type: 'warning'
        })
      })
    },
    // 获取问答列表
    getQAList: function (params) {
      this.siteId = params.siteId
      if (params.qaSelect === '') {
        this.qaSelect = params.qaSelect
      }
      let url = '/selectQaList'
      getQAList(url, params).then(response => {
        // console.log('获取人员列表' + JSON.stringify(response))
        if (response.data.ret === 1) {
          this.dataList = response.data.content.qaList
          this.totalPageNum = response.data.content.elementsCount
        }
      }).catch(response => {
        this.totalPageNum = 0
        this.$notify({
          title: '提示',
          message: '获取问答列表失败，请刷新重试',
          type: 'warning'
        })
      })
    },
    // 获取问答类型
    getQALType: function () {
      let url = '/getAllLabel'
      let params = {
        userId: this.userId
      }
      getQALType(url, params).then(response => {
        if (response.data.ret === 1) {
          this.qstypes = response.data.content.data.map(item => {
            return {
              labelId: item.labelId,
              labelName: item.labelName
            }
          })
        }
      }).catch(response => {
        this.totalPageNum = 0
        this.$notify({
          title: '提示',
          message: '获取问答类型失败，请刷新重试',
          type: 'warning'
        })
      })
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.dataList = []
      let params = {}
      if (this.qaSelect === '') {
        params = {
          pageSize: pageSize,
          pageNow: this.pageNow,
          siteId: this.siteId
        }
      } else {
        params = {
          pageSize: pageSize,
          pageNow: this.pageNow,
          qaSelect: this.qaSelect,
          siteId: this.siteId
        }
      }

      this.getQAList(params)
      console.log(`每页 ${pageSize} 条`)
    },
    handleCurrentChange (currentPage) {
      this.pageNow = currentPage - 1
      this.dataList = []
      let params = {}
      if (this.qaSelect === '') {
        params = {
          pageSize: this.pageSize,
          pageNow: currentPage - 1,
          siteId: this.siteId
        }
      } else {
        params = {
          pageSize: this.pageSize,
          pageNow: currentPage - 1,
          qaSelect: this.qaSelect,
          siteId: this.siteId
        }
      }

      this.getQAList(params)
      console.log(`当前页: ${currentPage - 1}`)
    },
    showExceptionMessage: function () {
      this.$notify({
        title: '提示',
        message: '网络异常！',
        type: 'error'
      })
    }

  }
}
</script>
<style scoped>
  .activecolor{
    background-color: #67c23a !important;
    color: #fff;
    width: 67px;
    text-align: center;
  }
  .grey{
    background-color: gainsboro;
    width: 67px;
    text-align: center;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/views/services/personsend.vue